import React, { useState, useEffect } from 'react';
import { Search, ChevronRight, Check } from 'lucide-react';
import { toast } from 'sonner';

const Scouting = () => {
  // State
  const [activeTab, setActiveTab] = useState('players');
  const [gradYear, setGradYear] = useState('');
  const [position, setPosition] = useState('');
  const [school, setSchool] = useState('');
  const [schoolState, setSchoolState] = useState('');
  const [xosRating, setXosRating] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [players, setPlayers] = useState([]);

  // Filter options
  const gradYears = ['2023', '2024', '2025', '2026', '2027'];
  const positions = ['QB', 'RB', 'WR', 'TE', 'OL', 'DL', 'LB', 'DB', 'K', 'P'];
  const states = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];
  const ratings = ['5-Star', '4-Star', '3-Star', '2-Star'];

  // Sample player data
  const samplePlayers = [
    { id: 1, name: 'Nathan Lamb', number: 12, school: 'College of the Sequoias', state: 'CA', year: 2023, position: 'QB', weight: 173, height: "6'3", avatar: 'NL', avatarBg: 'bg-orange-400' },
    { id: 2, name: 'Enzo Tedesco', number: 17, school: 'Independence CC', state: 'KS', year: 2025, position: 'QB', weight: null, height: "6'3", avatar: 'ET', avatarBg: 'bg-gray-400' },
    { id: 3, name: 'Josh Magana', number: 1, school: 'Reedley College', state: 'CA', year: 2023, position: 'QB', weight: 175, height: "6'1", avatar: 'JM', avatarBg: 'bg-green-400' },
    { id: 4, name: 'Lawson Pratt', number: 11, school: 'Pearl River CC', state: 'MS', year: 2026, position: 'QB', weight: 185, height: "6'0", avatar: 'LP', avatarBg: 'bg-purple-400' },
    { id: 5, name: 'Dante Moore', number: 5, school: 'Martin Luther King HS', state: 'MI', year: 2023, position: 'QB', weight: 235, height: "6'2", avatar: 'DM', avatarBg: 'bg-blue-400' },
    { id: 6, name: 'Kevin Lukasiewicz', number: 6, school: 'Chaffey College', state: 'CA', year: 2023, position: 'QB', weight: 200, height: "6'4", avatar: 'KL', avatarBg: 'bg-gray-500' },
    { id: 7, name: 'Cameron Davis', number: 13, school: 'Southwest Miss CC', state: 'MS', year: 2024, position: 'QB', weight: 260, height: "6'3", avatar: 'CD', avatarBg: 'bg-teal-400' },
    { id: 8, name: 'Eli Holstein', number: 10, school: 'Zachary HS', state: 'LA', year: 2023, position: 'QB', weight: 301, height: "6'3", avatar: 'EH', avatarBg: 'bg-yellow-400' },
    { id: 9, name: 'Dylan Rizk', number: 10, school: 'Cardinal Gibbons HS', state: 'FL', year: 2023, position: 'QB', weight: 197, height: "6'1", avatar: 'DR', avatarBg: 'bg-pink-400' },
    { id: 10, name: 'Liam Shepherd', number: 12, school: 'Memphis University School', state: 'TN', year: 2023, position: 'QB', weight: 166, height: "6'3", avatar: 'LS', avatarBg: 'bg-indigo-400' },
    { id: 11, name: 'Tao Hudson', number: 14, school: 'Varina HS', state: 'VA', year: 2023, position: 'QB', weight: 333, height: "6'2", avatar: 'TH', avatarBg: 'bg-cyan-400' },
    { id: 12, name: 'Braylen Ragland', number: 7, school: 'Fordson HS', state: 'TN', year: 2023, position: 'QB', weight: 186, height: "6'1", avatar: 'BR', avatarBg: 'bg-rose-400' },
    { id: 13, name: 'Lucas Hunter', number: 3, school: 'Grady-Paulding School', state: 'NY', year: 2023, position: 'QB', weight: 190, height: "6'3", avatar: 'LH', avatarBg: 'bg-emerald-400' },
    { id: 14, name: 'Collin Hurst', number: 8, school: 'Veterans HS', state: 'FL', year: 2025, position: 'QB', weight: 196, height: "6'3", avatar: 'CH', avatarBg: 'bg-amber-400' },
    { id: 15, name: 'Hilshon Bailey', number: 13, school: 'Ellsworth CC', state: 'IA', year: 2023, position: 'QB', weight: 199, height: "6'0", avatar: 'HB', avatarBg: 'bg-lime-400' },
    { id: 16, name: 'James Rawls', number: 11, school: 'Laurens HS', state: 'SC', year: 2023, position: 'QB', weight: 314, height: "6'11", avatar: 'JR', avatarBg: 'bg-violet-400' },
    { id: 17, name: 'Trasean Foster', number: 4, school: 'McKinley HS', state: 'OH', year: 2023, position: 'QB', weight: 180, height: "6'3", avatar: 'TF', avatarBg: 'bg-fuchsia-400' },
    { id: 18, name: 'Zane Flores', number: 12, school: 'Gretna HS', state: 'NE', year: 2023, position: 'QB', weight: 187, height: "6'3", avatar: 'ZF', avatarBg: 'bg-sky-400' },
    { id: 19, name: 'Jaxon Potter', number: 8, school: 'Santa Margarita Catholic HS', state: 'CA', year: 2023, position: 'QB', weight: 199, height: "6'4", avatar: 'JP', avatarBg: 'bg-red-400' },
    { id: 20, name: 'Ryan Staub', number: 16, school: 'Sierra Canyon HS', state: 'CA', year: 2023, position: 'QB', weight: 140, height: "6'1", avatar: 'RS', avatarBg: 'bg-orange-500' },
  ];

  useEffect(() => {
    setPlayers(samplePlayers);
  }, []);

  // Filter players
  const filteredPlayers = players.filter(player => {
    if (gradYear && player.year.toString() !== gradYear) return false;
    if (position && player.position !== position) return false;
    if (schoolState && player.state !== schoolState) return false;
    if (searchQuery && !player.name.toLowerCase().includes(searchQuery.toLowerCase()) && 
        !player.school.toLowerCase().includes(searchQuery.toLowerCase())) return false;
    return true;
  });

  return (
    <div className="min-h-screen bg-black p-4 md:p-6">
      <div className="max-w-[1800px] mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl md:text-3xl font-bold text-white">High School Search</h1>
          
          <div className="flex items-center gap-3">
            {/* Search Icon */}
            <button className="p-2 text-gray-400 hover:text-white transition-colors">
              <Search size={20} />
            </button>
            
            {/* Tab Toggle */}
            <div className="flex items-center bg-gray-800 rounded-lg p-1">
              <button
                onClick={() => setActiveTab('players')}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  activeTab === 'players' 
                    ? 'bg-orange-500 text-white' 
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                Players
              </button>
              <button
                onClick={() => setActiveTab('teams')}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  activeTab === 'teams' 
                    ? 'bg-orange-500 text-white' 
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                Teams
              </button>
            </div>
            
            {/* Checkmark */}
            <button className="p-2 text-gray-400 hover:text-white transition-colors">
              <Check size={20} />
            </button>
          </div>
        </div>

        {/* Results Count */}
        <p className="text-gray-400 text-sm mb-4">{filteredPlayers.length > 0 ? '4221' : filteredPlayers.length} RESULTS</p>

        {/* Filters */}
        <div className="grid grid-cols-5 gap-4 mb-6">
          {/* Grad Year */}
          <div>
            <label className="text-gray-400 text-xs uppercase mb-2 block">Grad Year</label>
            <select
              value={gradYear}
              onChange={(e) => setGradYear(e.target.value)}
              className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white text-sm appearance-none cursor-pointer"
            >
              <option value="">Select Item</option>
              {gradYears.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>

          {/* Position */}
          <div>
            <label className="text-gray-400 text-xs uppercase mb-2 block">Position</label>
            <select
              value={position}
              onChange={(e) => setPosition(e.target.value)}
              className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white text-sm appearance-none cursor-pointer"
            >
              <option value="">Select Item</option>
              {positions.map(pos => (
                <option key={pos} value={pos}>{pos}</option>
              ))}
            </select>
          </div>

          {/* School */}
          <div>
            <label className="text-gray-400 text-xs uppercase mb-2 block">School</label>
            <select
              value={school}
              onChange={(e) => setSchool(e.target.value)}
              className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white text-sm appearance-none cursor-pointer"
            >
              <option value="">Select Item</option>
            </select>
          </div>

          {/* School State */}
          <div>
            <label className="text-gray-400 text-xs uppercase mb-2 block">School State</label>
            <select
              value={schoolState}
              onChange={(e) => setSchoolState(e.target.value)}
              className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white text-sm appearance-none cursor-pointer"
            >
              <option value="">Select Item</option>
              {states.map(st => (
                <option key={st} value={st}>{st}</option>
              ))}
            </select>
          </div>

          {/* XOS Rating */}
          <div>
            <label className="text-gray-400 text-xs uppercase mb-2 block">XOS Rating</label>
            <select
              value={xosRating}
              onChange={(e) => setXosRating(e.target.value)}
              className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white text-sm appearance-none cursor-pointer"
            >
              <option value="">Select Item</option>
              {ratings.map(rating => (
                <option key={rating} value={rating}>{rating}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Players Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {filteredPlayers.map(player => (
            <div 
              key={player.id}
              className="bg-[#1a1a2e] border border-gray-800 rounded-xl p-4 hover:border-gray-600 transition-colors cursor-pointer"
              onClick={() => toast.info(`View ${player.name}'s profile`)}
            >
              <div className="flex items-center gap-4">
                {/* Avatar */}
                <div className={`w-14 h-14 ${player.avatarBg} rounded-full flex items-center justify-center text-white font-bold text-lg flex-shrink-0`}>
                  {player.avatar}
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="text-white font-semibold truncate">{player.name}</h3>
                    <span className="text-gray-400 text-sm">#{player.number}</span>
                  </div>
                  <p className="text-gray-500 text-sm truncate">{player.school}, {player.state}</p>
                </div>

                {/* Arrow */}
                <ChevronRight size={20} className="text-gray-600 flex-shrink-0" />
              </div>

              {/* Stats Row */}
              <div className="flex items-center gap-4 mt-4 text-sm">
                <span className="text-gray-400">{player.year}</span>
                <span className="text-white font-medium">{player.position}</span>
                {player.weight && <span className="text-gray-400">{player.weight}</span>}
                <span className="text-gray-400">{player.height}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {filteredPlayers.length === 0 && (
          <div className="text-center py-20">
            <Search size={48} className="mx-auto mb-4 text-gray-600" />
            <p className="text-gray-400">No players found matching your criteria</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Scouting;
